import { createContext } from 'react';

const TickerItemContext = /** @__PURE__ */ createContext(undefined);

export { TickerItemContext };
